import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { getStoredConsent, setConsent } from "./useAdConsent";

/**
 * Lehký GDPR banner pro souhlas s personalizovanými reklamami.
 * Bez souhlasu se reklamy načítají s data-npa="1" (non-personalized).
 */
export function AdConsentBanner() {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (getStoredConsent() === "unknown") {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  if (!show) return null;

  const choose = (v: "granted" | "denied") => {
    setConsent(v);
    setShow(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4 pointer-events-none" key={i18n.language}>
      <div className="pointer-events-auto mx-auto max-w-2xl rounded-xl border border-border bg-background/95 backdrop-blur shadow-elevated p-4 sm:p-5">
        <p className="text-sm leading-relaxed">
          {t("adConsent.message")}{" "}
          <Link to="/cookies" className="underline text-primary">
            {t("adConsent.more")}
          </Link>
          .
        </p>
        <div className="mt-3 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
          <Button variant="outline" size="sm" onClick={() => choose("denied")}>
            {t("adConsent.deny")}
          </Button>
          <Button size="sm" onClick={() => choose("granted")}>
            {t("adConsent.accept")}
          </Button>
        </div>
      </div>
    </div>
  );
}
